import styled from 'styled-components';

const ContentContainer = styled.div`
  display: flex;
  max-width: 250px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default ContentContainer;
